import * as React from 'react';

interface ButtonProps {
  label: string | React.JSX.Element;
  variant?: string;
  onClick: () => void;
  isDisabled?: boolean;
  className?: string;
  textClassName?: string;
}

export const SplitFulfillmentCTA = ({
  label,
  onClick,
  isDisabled = false,
  className,
  textClassName,
}: ButtonProps) => {
  return (
    <button
      className={`${className} ${textClassName}`}
      onClick={onClick}
      disabled={isDisabled}
      style={{
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        fontSize: 'smaller',
        textDecoration: isDisabled ? 'none' : 'underline',
        // --bark-fg is only defined in dark mode, so light mode stays black.
        color: isDisabled ? 'gray' : 'var(--bark-fg, black)',
      }}
    >
      {label}
    </button>
  );
};
